import Button from '../Buttons/Button/Button';
import Popover from '../Popovers/Popover/Popover';

import Content from './components/Content/Content';

const CalendarExport = ({ exportRange }) => {
  return (
    <Popover
      position="left"
      panelClassName="w-[500px] p-0"
      customButtonTrigger={
        <Button
          text="Export"
          size="xs"
          variant="tertiary"
          icon="export-mono"
          iconColor="neutral"
          className="my-2"
        />
      }>
      {({ closePopover }) => <Content {...{ closePopover, exportRange }} />}
    </Popover>
  );
};

export default CalendarExport;
